import { useTranslation } from 'react-i18next';
import { IPurchaseRequestRow } from '../../types';
import EditAutomaticPurchaseRequestLine from '../form/EditAutomaticPurchaseRequestLine';
import EditPurchaseRequestLine from '../form/EditPurchaseRequestLine';
import { EnhancedDialog } from 'components/enhanced';

interface EditPurchaseRequestLineDialogProps {
  open: boolean;
  onClose: () => void;
  editPurchaseRequestLine: IPurchaseRequestRow;
  automaticGenerated: boolean;
  onSubmitEdit: (data: any) => void;
  editContractOptions?: any[];
}

const EditPurchaseRequestLineDialog = ({
  open,
  onClose,
  editPurchaseRequestLine,
  automaticGenerated,
  onSubmitEdit,
  editContractOptions
}: EditPurchaseRequestLineDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      submitLabel={t('actions.confirm')}
      open={open}
      onClose={onClose}
      maxWidth="md"
      title={
        automaticGenerated
          ? `${t('pages.purchase-requests.automatic.edit-line')}`
          : t('pages.purchase-requests.edit-line')
      }
      submitButtonProps={{
        type: 'submit',
        form: 'editPurchaseRequestLine'
      }}>
      {automaticGenerated ? (
        <EditAutomaticPurchaseRequestLine
          purchaseRequestLine={editPurchaseRequestLine}
          contracts={editContractOptions}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <EditPurchaseRequestLine
          purchaseRequestLine={editPurchaseRequestLine}
          onSubmit={onSubmitEdit}
        />
      )}
    </EnhancedDialog>
  );
};

export default EditPurchaseRequestLineDialog;
